import { Badge, Tooltip } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ROUTE_NOTIFICATION_INBOX } from '@/constants/routes';

type Props = {
  count: number;
};

export function MessageBellBadge({ count }: Props) {
  const navigate = useNavigate();

  return (
    <Tooltip title={count > 0 ? `${count} 条未读消息` : '我的消息'}>
      <Badge count={count} overflowCount={99} size="small">
        <MessageOutlined
          style={{ fontSize: 18, cursor: 'pointer' }}
          onClick={() => navigate(ROUTE_NOTIFICATION_INBOX)}
        />
      </Badge>
    </Tooltip>
  );
}
